import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { HexModalScreenModule } from "@hex/angular/modal-screen";
import { CommonUtilsModule } from "../../../shared/components/common-utils/common-utils.module";

import { filesPropProvider } from "../../../+authenticated/+product-detail/state-props";
import { CommonFormModule } from "../../../shared/components/common-form/common-form.module";
import { CommonListModule } from "../../../shared/components/common-list/common-list.module";
import { DownloadLinkModule } from "../../../shared/components/download-link/download-link.module";
import { RowSelectionModule } from "../../../shared/components/row-selection/row-selection.module";
import { AttachmentTypeSelectorModule } from "../attachment-type-selector/attachment-type-selector.module";
import { FileAttachmentManagerComponent } from "./file-attachment-manager.component";

@NgModule({
    imports: [
        CommonModule,
        CommonUtilsModule,
        CommonFormModule,
        CommonListModule,
        DownloadLinkModule,
        RowSelectionModule,
        HexModalScreenModule,
        AttachmentTypeSelectorModule,
    ],
    exports: [
        FileAttachmentManagerComponent,
    ],
    declarations: [
        FileAttachmentManagerComponent,
    ],
    providers: [
        filesPropProvider,
    ],
})
export class FileAttachmentManagerModule {
}
